import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthTokenService } from '../../../ppb/shared/services/auth-token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  {
  constructor(
    private authTokenService: AuthTokenService,
    private router: Router
  ) { }

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkLogin();
  }

  canActivateChild(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(_route, state);
  }

  canLoad(_route: Route): boolean {
    return this.checkLogin();
  }

  checkLogin(): boolean {
    if (this.authTokenService.checkAuth()) {
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
}
